import { render, staticRenderFns } from "./MensajeAlEnviarForm.vue?vue&type=template&id=2fad208f&"
import script from "./MensajeAlEnviarForm.vue?vue&type=script&lang=ts&"
export * from "./MensajeAlEnviarForm.vue?vue&type=script&lang=ts&"
import style0 from "./MensajeAlEnviarForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports